import { useEffect, useState } from "react";

import { useTitleStore } from "store";
import { TitleCompanies } from "types/entities";
import {
  GetTitleCompaniesFunction,
  GetTitleCompaniesFunctionParams,
} from "types/functions/getTitleCompanies";

import { BaseAsyncHook, BaseAsyncHookInput } from "types/hooks";
import { parseAsyncHookConfiguration } from "utils";

interface UseGetTitleCompanies extends BaseAsyncHook {
  getTitleCompanies: GetTitleCompaniesFunction;
  titleCompanies: TitleCompanies[];
}

interface UseGetTitleCompaniesInput
  extends BaseAsyncHookInput,
    GetTitleCompaniesFunctionParams {}

export const useGetTitleCompanies = (
  props?: UseGetTitleCompaniesInput
): UseGetTitleCompanies => {
  const config = parseAsyncHookConfiguration(props?.configuration);
  const _titleCompanies = useTitleStore((state) => state.titleCompanies);
  const _getTitleCompanies = useTitleStore((state) => state.getTitleCompanies);

  const [isLoading, setIsLoading] = useState<boolean>(
    config.preventNetworkRequest ? false : true
  );
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    if (config.preventNetworkRequest === false) getTitleCompanies();
  }, []);

  const getTitleCompanies = async () => {
    try {
      setIsLoading(true);
      setIsError(false);
      const titleCompanies = await _getTitleCompanies();
      return titleCompanies;
    } catch (error) {
      setIsError(true);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  return {
    error: isError,
    loading: isLoading,
    getTitleCompanies,
    titleCompanies: _titleCompanies,
  };
};
